import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { UploadStatus } from '@hub-la/fe-asset';
import { isEmpty } from 'lodash';
import { useState, useEffect } from 'react';

const useVideoStatus = videos => {
  const [status, setStatus] = useState([]);
  useEffect(() => {
    if (isEmpty(videos)) {
      return;
    }
    setStatus(videos.map(video => ({
      name: video.file.name,
      status: UploadStatus.NO_CALLED
    })));
  }, [videos]);
  const updateStatus = (name, status) => {
    setStatus(_ => _.map(s => s.name === name ? Object.assign(Object.assign({}, s), {
      status
    }) : s));
  };
  const getStatus = name => {
    var _a, _b;
    return (_b = (_a = status.find(s => s.name === name)) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : UploadStatus.NO_CALLED;
  };
  return {
    updateStatus,
    getStatus
  };
};

export { useVideoStatus };
